/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { AMMLibTester } from '../AMMLibTester'

export class AMMLibTester__factory extends ContractFactory {
  constructor(
    linkLibraryAddresses: AMMLibTesterLibraryAddresses,
    signer?: Signer
  ) {
    super(
      _abi,
      AMMLibTester__factory.linkBytecode(linkLibraryAddresses),
      signer
    )
  }

  static linkBytecode(
    linkLibraryAddresses: AMMLibTesterLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$94a4c7b9bd68bc1262fd256c9f16212cff\\$__', 'g'),
      linkLibraryAddresses['__$94a4c7b9bd68bc1262fd256c9f16212cff$__']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(overrides?: Overrides): Promise<AMMLibTester> {
    return super.deploy(overrides || {}) as Promise<AMMLibTester>
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): AMMLibTester {
    return super.attach(address) as AMMLibTester
  }
  connect(signer: Signer): AMMLibTester__factory {
    return super.connect(signer) as AMMLibTester__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AMMLibTester {
    return new Contract(address, _abi, signerOrProvider) as AMMLibTester
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      },
      {
        internalType: 'uint128',
        name: '_mint',
        type: 'uint128'
      }
    ],
    name: 'addBalance',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'clear',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      }
    ],
    name: 'getMintAmount',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      },
      {
        internalType: 'uint128',
        name: '_burn',
        type: 'uint128'
      }
    ],
    name: 'getWithdrawableAmount',
    outputs: [
      {
        internalType: 'uint128',
        name: 'withdrawableAmount',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickId',
        type: 'uint32'
      }
    ],
    name: 'makeSnapshot',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'pool',
    outputs: [
      {
        internalType: 'address',
        name: 'aggregator',
        type: 'address'
      },
      {
        internalType: 'contract IOptionVault',
        name: 'optionVault',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'collateral',
        type: 'address'
      },
      {
        internalType: 'uint64',
        name: 'lastBoughtTimestamp',
        type: 'uint64'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      },
      {
        internalType: 'uint128',
        name: '_burn',
        type: 'uint128'
      }
    ],
    name: 'removeBalance',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickId',
        type: 'uint32'
      },
      {
        internalType: 'uint128',
        name: '_loss',
        type: 'uint128'
      }
    ],
    name: 'testAddLoss',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickId',
        type: 'uint32'
      },
      {
        internalType: 'uint128',
        name: '_profit',
        type: 'uint128'
      }
    ],
    name: 'testAddProfit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_index',
        type: 'uint32'
      }
    ],
    name: 'ticks',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'supply',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'balance',
            type: 'uint128'
          },
          {
            internalType: 'int128',
            name: 'unrealizedPnL',
            type: 'int128'
          },
          {
            internalType: 'uint128',
            name: 'lastSupply',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'lastBalance',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'secondsPerLiquidity',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'burnReserved',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'reservationForWithdrawal',
            type: 'uint128'
          }
        ],
        internalType: 'struct AMMLib.Tick',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const _bytecode =
  '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__$94a4c7b9bd68bc1262fd256c9f16212cff$__90636a39c38c9061043b908490889088908890600401610679565b60206040518083038186803b15801561045357600080fd5b505af4158015610467573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061048b91906105c0565b949350505050565b6040516368e32f3160e11b815260009073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063d1c65e629061043b908490889088908890600401610679565b604051639667903d60e01b815260009073__$94a4c7b9bd68bc1262fd256c9f16212cff$__90639667903d9061043b908490889088908890600401610679565b60405163377e576160e01b815260009073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063377e57619061043b908490889088908890600401610679565b50805460008255600202906000526020600020908101906105749190610577565b50565b5b808211156105a85780546001600160a81b03191681556001810180546001600160801b0319169055600201610578565b5090565b803563ffffffff811681146103be57600080fd5b6000602082840312156105d1578081fd5b81516105dc816107ad565b9392505050565b6000602082840312156105f4578081fd5b6105dc826105ac565b6000806040838503121561060f578081fd5b610618836105ac565b91506020830135610628816107ad565b809150509250929050565b600080600060608486031215610647578081fd5b610650846105ac565b925061065e602085016105ac565b9150604084013561066e816107ad565b809150509250925092565b93845263ffffffff9283166020850152911660408301526001600160801b0316606082015260800190565b6000610100820190506001600160801b038084511683528060208501511660208401526040840151600f0b60408401528060608501511660608401528060808501511660808401525060a083015161070760a08401826001600160801b03169052565b5060c083015161072260c08401826001600160801b03169052565b5060e083015161073d60e08401826001600160801b03169052565b5092915050565b60006001600160801b0380831681851680830382111561076657610766610797565b01949350505050565b60006001600160801b038381169083168181101561078f5761078f610797565b039392505050565b634e487b7160e01b600052601160045260246000fd5b6001600160801b038116811461057457600080fdfea164736f6c6343000802000a'

export interface AMMLibTesterLibraryAddresses {
  ['__$94a4c7b9bd68bc1262fd256c9f16212cff$__']: string
}
